module.exports = __webpack_public_path__ + "frxxyy/img/entry.mp4?e475a9e5";